<template>
  <Layout id="layout-container">
    <Icon
      @click="showMenu()"
      v-if="this.$store.state.sider_menu_collapsed"
      type="md-menu"
      class="clickable font-size-28"
      style="
        position: absolute;
        z-index: 9999;
        color: var(--themColor);
        line-height: 60px;
        left: 10px;
      "
    />
    <Header class="header-area">
      <Menu mode="horizontal" theme="dark">
        <div class="header-container">
          <div class="logo" v-if="!this.$store.state.sider_menu_collapsed">
            <img src="../assets/logo2.png" style="height: 64px; width: 120px" />
          </div>
          <!-- <div class="title-area" :style="this.$store.state.sider_menu_collapsed?'border:0px':''">
            <div id="mainTitle">{{ this.$store.getters.siteInfo.siteName }}</div>
             <div id="subTitle">{{ this.$store.getters.siteInfo.siteEngName }}</div> -->
          <!-- <div id="mainTitle">PLATINUM</div>
            <div id="subTitle">员工自助管理系统</div> -->
          <!-- </div> -->
        </div>
        <div v-if="this.$store.getters.userInfo || userInfo" class="layout-nav">
          <MenuItem name="1">
            <!-- <img
              class="headerIcon"
              @click="homePage"
              src="../assets/headerHome.png"
              alt=""
            /> -->
            <!-- <Icon   type="ios-help-outline" size="40" color="#7bd9a5" style="color:#7bd9a5"></Icon> -->
            <Icon
              class="headerIcon"
              size="36"
              color="#7bd9a5"
              type="ios-help-circle-outline"
              style="margin-top: 10px"
              @click="toHelpPage()"
            />
          </MenuItem>
          <MenuItem name="1">
            <Dropdown>
              <a href="javascript:void(0)" style="color: #6f1df6">
                <!-- <Icon type="md-globe" style="color:#6F1DF6;cursor: pointer;margin-top:8px" size="28" ></Icon> -->
                <img
                  class="headerIcon"
                  src="../assets/headerLanguage.png"
                  alt=""
                />
              </a>
              <DropdownMenu slot="list">
                <DropdownItem
                  :class="{ selectLangeColor: selectLange == 'zh' }"
                  @click.native="changeLange('zh')"
                  >中文</DropdownItem
                >
                <DropdownItem
                  :class="{ selectLangeColor: selectLange == 'en' }"
                  @click.native="changeLange('en')"
                  >English</DropdownItem
                >
              </DropdownMenu>
            </Dropdown>
          </MenuItem>
          <MenuItem
            name="1"
            v-if="
              this.$store.getters.siteInfo.messagePageid &&
              !this.$store.state.sider_menu_collapsed
            "
          >
         
            <Dropdown>
              <router-link
                to="/61AB63E6DE1EF633AB0757BB3048AF07B7578999FE53335EBA610C6A6F738319/A3FFBEBFDB713E27"
              >
               <!-- <router-link
                to="/C0F994D621530A70/A3FFBEBFDB713E27"
              > -->
                <Badge class="notifications" :count="messageCnt">
                  <!-- <Icon type="ios-notifications" size="26" style="color:#6F1DF6;cursor: pointer"/> -->
                  <img
                    class="headerIcon"
                    src="../assets/headerMessage.png"
                    alt=""
                  />
                </Badge>
              </router-link>
              <DropdownMenu slot="list" v-if="true">
                <DropdownItem
                  @click.native="goContinuousPage(item)"
                  v-for="(item, index) in messageList"
                  :key="index"
                >
                  <Tag color="green">{{ item.relation }}</Tag>
                  <span style="font-weight: bold; color: #000">{{
                    item.userName
                  }}</span>
                  在 {{ item.date }} 的通知中发布了反馈
                  <span style="margin-left: 20px; color: #dadada">{{
                    item.date
                  }}</span>
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </MenuItem>
          <MenuItem name="2" style="color: #000000; cursor: pointer">
            <Dropdown>
              <a href="javascript:void(0)" style="color: #ffffff">
                <img class="headerIcon" src="../assets/headerUser.png" alt="" />
                <span style="font-weight: bold">
                  {{ lang == "zh" ? userInfo.userName : userInfo.eName }}</span
                >
                <Icon type="md-arrow-dropdown" style="color: #ffffff" />
              </a>

              <DropdownMenu slot="list">
                <DropdownItem @click.native="logout()">退出</DropdownItem>
                <!-- <DropdownItem :class="{'selectLangeColor' : selectLange == 'en'}" @click.native="changeLange('en')">English</DropdownItem> -->
              </DropdownMenu>
            </Dropdown>
            <!-- <Icon type="ios-contact" size="26"  style="color:#6F1DF6;cursor: pointer" /> -->

            <!-- {{ this.$store.getters.userInfo.userName }} -->
          </MenuItem>
          <!-- <MenuItem name="3" v-if="!this.$store.state.sider_menu_collapsed">
            <a class="exitlink" @click="logout()">退出</a>
          </MenuItem> -->
        </div>
      </Menu>
    </Header>
    <Layout style="position: relative">
      <!-- 用户菜单 -->
      <Sider
        :breakpoint="this.breakpoint"
        collapsible
        collapsed-width="0"
        class="menu-area"
        width="220"
        v-model="$store.state.sider_menu_collapsed"
      >
        <Menu
          theme="dark"
          class="menuClass"
          :accordion="true"
          :active-name="activeName"
        >
          <div v-for="(item, index) in menuList" :key="index">
            <Submenu
              :name="index"
              v-if="item.childMenuList && item.childMenuList.length > 0"
            >
              <template slot="title">
                <Icon :type="item.icon" />
                {{ lang == "zh" ? item.chName : item.enName }}
              </template>
              <MenuItem
                :name="index + '-' + index1"
                v-for="(item1, index1) in item.childMenuList"
                :key="index1"
                @click.native="toPage(item1, index, index + '-' + index1)"
              >
                <p class="showBorder"></p>
                <div class="selectBg"></div>
                <Icon v-if="item1.icon" :type="item1.icon" />
                {{ lang == "zh" ? item1.chName : item1.enName }}
              </MenuItem>
            </Submenu>
            <MenuItem
              :name="'19-' + index"
              v-else
              @click.native="toPage(item, index, '19-' + index)"
            >
              <p class="showBorder"></p>
              <div class="selectBg"></div>
              <Icon :type="item.icon" />
              {{ lang == "zh" ? item.chName : item.enName }}
            </MenuItem>
          </div>
        </Menu>
        <!-- <j2-menu
          ref="menu1"
          :data-list="this.$store.getters.menuInfo || menuList"
          :selected-menu-id="this.$store.getters.curMenuId"
          @on-select="redirect"
        ></j2-menu>-->
      </Sider>

      <!-- 用户菜单 -->
      <Drawer
        width="200"
        placement="left"
        :closable="false"
        v-model="$store.state.drawer_menu_shown"
        :styles="menuStyle"
      >
        <j2-menu
          ref="menu2"
          :data-list="this.$store.getters.menuInfo || menuList"
          :selected-menu-id="this.$store.getters.curMenuId"
          @on-select="redirect"
        ></j2-menu>
      </Drawer>

      <!-- 栅格布局 -->
      <GridContent
        v-if="$store.getters.curPageDefine.pageInfo.pageType == '0'"
      ></GridContent>
      <Drawer
        title="主题设置"
        :closable="false"
        v-model="themDrawer"
        width="720"
        :mask-closable="false"
      >
        <themDrawerVue
          :themInfo="this.themInfo"
          @onCancel="themDrawer = false"
          @onSubmit="themOnSub"
        />
      </Drawer>
      <div @click="themDrawer = true" class="cs-them-butn">
        <Icon type="md-create" />
      </div>
    </Layout>
  </Layout>
</template>

<script>
import axios from "axios";
import CommonUtil from "../util/CommonUtil";
import APIUtil from "../util/APIUtil";
import GridContent from "../contents/GridContent";
import { dimensionMap } from "view-design/src/utils/assist.js";
import SockJS from "sockjs-client";
import Stomp from "stompjs";
import themDrawerVue from "./themDrawer.vue";
export default {
  components: {
    GridContent,
    themDrawerVue,
  },

  data() {
    return {
      themDrawer: false,
      messageCnt: 0,
      intervalId: null,
      menuStyle: {
        padding: "0px",
        backgroundColor: "#515a6e",
      },
      breakpoint: "sm",
      activeName: "",
      activeNameOld: "",
      stompClient: null,
      flag: false,
      flagMenu: false,
      noticeMethod: ["open", "info", "success", "warning", "error"],
      menuList: [],
      userInfo: "",
      selectLange: "",
      emailLink: {
        serialnumber: "",
        email: "",
      },
      messageList: [],
    };
  },
  async created() {
    this.emailLink = this.$route.query;
    if (this.$route.query.serialnumber && this.$route.query.email) {
      await this.getUserMenuInfo();
    } else {
      // 初始化数据
      this.fetchData();
      this.getMenuInfo();
      this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      this.$store.state.selectLange = localStorage.getItem("locale") || "zh";
      this.menuList = JSON.parse(sessionStorage.getItem("menuInfo"));
    }
    // // 初始化数据
    // this.fetchData();

    // 初始化WebSocket连接
    await this.initSocket();
  },

  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    if (this.stompClient) {
      this.stompClient.disconnect();
    }
  },
  computed: {
    //国际化监听
    lang() {
      return this.$store.getters.selectLangeData;
    },
    themInfo() {
      return this.$store.getters.getThemStatus;
    },
  },
  watch: {
    "$store.state.noticeBeReadId"(newVal, oldVal) {
      this.initSocket();
    },
  },
  methods: {
    goContinuousPage(item) {
      this.$router.push({
        path: "/61AB63E6DE1EF633AB0757BB3048AF07B7578999FE53335EBA610C6A6F738319/A3FFBEBFDB713E27",
        query: {
          id: item.id,
          search_serialnumber: item.send_serialnumber,
        },
      });
    },
    themOnSub(themInfo) {
      console.log(themInfo, "teh");
      themInfo.id = 1;
      this.$store.commit("setThemStatus", JSON.stringify(themInfo));
      this.themDrawer = false;
    },
    getUserMenuInfo() {
      axios.post("/empInfo/UserInformation", this.emailLink).then((res) => {
        if (res) {
          this.$store.commit("menuInfo", res);
          sessionStorage.setItem("menuInfo", JSON.stringify(res));
          this.menuList = res.menuList;
          this.$store.commit("loginInfo", res);
          sessionStorage.setItem("accessToken", res.accessToken);
          sessionStorage.setItem("userInfo", JSON.stringify(res.userInfo));
          this.userInfo = res.userInfo;
          this.$store.state.selectLange =
            localStorage.getItem("locale") || "zh";
          // this.menuList=JSON.parse(sessionStorage.getItem('menuInfo'))
        }
      });
    },
    getMenuInfo() {
      let Obj = {
        menuId: "S0C",
      };
      // // 原查询菜单
      // axios.post("/siteInfo/menu", Obj).then((res) => {
      //      this.menuList = res
      //   })
      // 根据权限查询菜单
      axios.post("/siteInfo/getPowerMenu", Obj).then((res) => {
        this.menuList = res;
      });
    },
    toPage(menuInfo, index, index1) {
      if (
        sessionStorage.getItem("menuId") != menuInfo.menuId &&
        (sessionStorage.getItem("menuId") == "S0C03" ||
          sessionStorage.getItem("menuId") == null)
      ) {
        let obj = JSON.parse(sessionStorage.getItem("myAch")) || {};
        if (obj.collapseShow && obj.isSelf && obj.tabsValue != "STI更新") {
          let flag = true;
          this.$Modal.confirm({
            title: this.$t("exitSave"),
            okText: "确定",
            cancelText: "取消",
            onOk: () => {
              // 判断是否进入到我的绩效
              if (menuInfo.menuId == "S0C03") {
                this.activeNameOld = index1;
                sessionStorage.setItem("refresh", true);
              }
              // 不管是否提示都清空
              sessionStorage.removeItem("myAch");
              // this.$router.push("/" + menuInfo.groupId + "/" + menuInfo.pageId);
              CommonUtil.menuClickHandler(this, menuInfo);
            },
            onCancel: () => {
              this.activeName = this.activeNameOld;
              flag = true;
            },
          });
          if (flag) {
            return;
          }
        }
      }
      // 判断是否进入到我的绩效
      if (menuInfo.menuId == "S0C03") {
        this.activeNameOld = index1;
        sessionStorage.setItem("refresh", true);
      }
      // 不管是否提示都清空
      sessionStorage.removeItem("myAch");
      // this.$router.push("/" + menuInfo.groupId + "/" + menuInfo.pageId);
      CommonUtil.menuClickHandler(this, menuInfo);
    },
    // 页面初期化
    fetchData() {
      APIUtil.findSiteMenu(this, 2);
    },
    changeLange(lange) {
      if (lange != localStorage.getItem("locale")) {
        localStorage.setItem("locale", lange);
        this.$store.state.selectLange = lange;
        this.$i18n.locale = lange;
        this.selectLange = lange;
      }
    },
    // 初始化WebSocket连接
    initSocket: function () {
      // 创建WebSocket对像
      let socket = new SockJS(process.env.API_ROOT + "/ws");
      // 限制连接协议
      socket._transportsWhitelist = [
        "jsonp-polling",
        "xdr-polling",
        "xhr-polling",
        "xhr-streaming",
        "xdr-streaming",
      ];
      let stompClient = Stomp.over(socket);

      let header = {
        "access-token":
          this.$store.getters.accessToken ||
          sessionStorage.getItem("accessToken"),
      };

      // 创建WebSocket连接
      stompClient.connect(
        header,
        () => {
          // 保存连接
          console.log("connect ok");
          this.stompClient = stompClient;

          // 当前用户信息
          let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));

          // 监听用户ID
          stompClient.subscribe("/topic/" + loginUser.userId, (response) => {
            if (response.body) {
              // 通知信息
              let jsonResult = JSON.parse(response.body);
              console.log(jsonResult, "js");
              // 通知件数
              if (jsonResult.noticeCnt != null) {
                this.messageCnt = jsonResult.noticeCnt;
              }
              if (jsonResult.notice) {
                this.messageList = jsonResult.notice || [];
              }
              // 表示通知
              // if (jsonResult.notice) {
              //   this.$Notice[this.noticeMethod[jsonResult.notice.iconType]]({
              //     name: jsonResult.notice.noticeId,
              //     title: jsonResult.notice.noticeTitle,
              //     duration: 10,
              //     render: h => {
              //       // 通知内容
              //       var noticeContent = [];
              //       if (jsonResult.notice.noticeContent) {
              //         noticeContent.push(
              //           h("span", {
              //             domProps: {
              //               innerHTML: CommonUtil.replaceAll(
              //                 jsonResult.notice.noticeContent,
              //                 "\n",
              //                 "<br>"
              //               )
              //             }
              //           })
              //         );
              //         noticeContent.push(h("br"));
              //       }
              //       // 详细信息链接
              //       if (jsonResult.notice.noticeLink) {
              //         noticeContent.push(h("br"));
              //         noticeContent.push(
              //           h(
              //             "a",
              //             {
              //               on: {
              //                 click: () => {
              //                   // 关闭当前通知
              //                   this.$Notice.close(jsonResult.notice.noticeId);

              //                   // 跳转到详情页面
              //                   let siteId = this.$route.params.site_id;
              //                   if (siteId) {
              //                     this.$router.push(
              //                       "/" + siteId + jsonResult.notice.noticeLink
              //                     );
              //                   } else {
              //                     this.$router.push(
              //                       jsonResult.notice.noticeLink
              //                     );
              //                   }
              //                 }
              //               }
              //             },
              //             "详细信息"
              //           )
              //         );
              //       }
              //       return h("span", noticeContent);
              //     }
              //   });
              // }
            }
          });

          // 用户登陆通知
          stompClient.send("/app/list", header, loginUser.userId);
        },
        (err) => {
          console.log(err);
          if (err) {
            setTimeout(this.initSocket, 10000);
          }
          // 10秒重连
        }
      );
    },

    // 菜单点击
    redirect: function (menuInfo) {
      console.log(menuInfo);
      CommonUtil.menuClickHandler(this, menuInfo);
      this.$store.state.drawer_menu_shown = false;
    },
    // 显示菜单栏
    showMenu() {
      let matchMedia = window.matchMedia;
      console.log(matchMedia);
      if (matchMedia(`(max-width: ${dimensionMap[this.breakpoint]})`).matches) {
        this.$store.state.drawer_menu_shown = true;
      } else {
        this.$store.state.sider_menu_collapsed = false;
      }
    },
    // 退出
    logout() {
      sessionStorage.clear();
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
      if (this.stompClient) {
        this.stompClient.disconnect();
      }

      let siteId = this.$route.params.site_id;
      if (siteId) {
        window.location.href = "/" + siteId;
      } else {
        window.location.href = "/";
      }
      if (this.$msal.isAuthenticated) {
        this.$msal.signOut();
      }
    },
    homePage() {
      //  window.location.href = "/";
      // window.location.href = '/'+'45F97DE9E9FF67FDCC9567AB3D60F484/A3FFBEBFDB713E27'
      // let {href} = this.$router.resolve({path: `/710B8EBEFAFA4118E92BAF7238FF712F/A3FFBEBFDB713E27`});
      // window.open(href, '_blank');
      this.$router.push("/710B8EBEFAFA4118E92BAF7238FF712F/A3FFBEBFDB713E27");
    },
    toHelpPage() {
      this.$router.push("/6BC2CA32E3F53EF18D6CAC77EBA9127E/A3FFBEBFDB713E27");
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-area >>> .ivu-menu-submenu-title,
.menu-area >>> .ivu-menu-item {
  font-weight: bold !important;
  font-size: 16px !important;
}
.cs-them-butn {
  position: absolute;
  right: 20px;
  bottom: 10%;
  width: 50px;
  height: 50px;
  line-height: 50px;
  font-size: 20px;
  border: 1px solid var(--themColor);
  color: var(--themColor);
  border-radius: 50%;
  text-align: center;
  cursor: pointer;
}

#layout-container {
  position: fixed;
  display: flex;
  width: 100%;
  height: 100%;
}

.header-area {
  padding: 0px 0px;
  // box-shadow: 2px 2px 8px 2px rgba(50, 138, 245, 0.2);
  z-index: 999;
}

.header-area .ivu-menu-dark {
  background: transparent;
}

// /deep/ .ivu-badge-count {
//   height: 18px;
//   width: 18px;
//   min-width: 18px;
//   padding: 0px;
//   line-height: 15px;
// }

.header-container {
  float: left;
  display: flex;
  align-items: center;
}

.header-container > div {
  float: left;
}

.header-container .logo {
  height: 40px;
  // margin-top: 4px;
  img {
    width: 200px;
    margin-left: 25px;
  }
}

// .header-container .logo img {
//   height: 55px;
//   line-height: normal;
// }

.header-container .title-area {
  padding-left: 15px;
  height: 64px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  // border-left: 2px solid white;
}

.header-container .title-area #mainTitle {
  font-size: 18px;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: bolder;
  color: var(--themColor);
  line-height: normal;
}

.header-container .title-area #subTitle {
  font-size: 15px;
  color: var(--themColor);
  font-weight: bold;
  line-height: normal;
}

.mainTitle {
  /* width: 100px; */
  height: 30px;
  line-height: 30px;
  /* background: #5b6270; */
  border-radius: 3px;
  float: left;
  position: relative;
  top: 15px;
  left: 20px;
  color: white;
  font-weight: bolder;
  font-size: 26px;
}

.layout-nav {
  float: right;
}

.ivu-layout {
  overflow: auto;
}

.notifications {
  display: inline;
}

.exitlink {
  color: #000000;
}

.exitlink:hover {
  color: #000000;
  text-decoration: underline;
}

.menu-area {
  overflow: auto;
  // margin-bottom: 18px;
}

.menu-area /deep/ .ivu-layout-sider-trigger {
  height: 18px;
  line-height: 18px;
  /* display: none; */
}

.menu_btn {
  position: absolute;
  top: 15px;
  left: 15px;
}

.ivu-menu /deep/ .ivu-menu-item > span > i,
.ivu-menu /deep/ .ivu-menu-submenu > .ivu-menu-submenu-title > span > i {
  margin-right: 8px;
  width: 16px;
  text-align: center;
}

@media (max-width: 576px) {
  .header-container .title-area {
    padding-left: 0px;
    border-left: 0px;
  }
  .header-area {
    padding: 0px 50px;
  }
  .ivu-layout-header {
    padding: 0px 0px 0px 50px;
  }
  .ivu-menu-horizontal .ivu-menu-item,
  .ivu-menu-horizontal .ivu-menu-submenu {
    padding: 0 10px;
  }
}
#mainTitle {
  // line-height: 64px !important;
}
.menu-area::-webkit-scrollbar {
  width: 0 !important;
}
.headerIcon {
  width: 40px;
  height: 40px;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/layouts/ConsoleLayout.vue